export { default } from '@shikijs/langs/astro'
